module.exports = __webpack_public_path__ + "img/approve-green.6e4f8980.svg";